import { useMemo } from "react";
import cn from "classnames";
import { ShipmentType } from "entities/shared/shipmentCard.types";
import { useAirGetTagsQuery } from "entities/AirTags";
import { searchFilterStore } from "entities/SearchFilter";
import { useSeaGetTagsQuery } from "entities/SeaTags/api/hooks/useGetTagsQuery";
import { useAppSelector } from "shared/lib/redux";
import { Preloader } from "shared/ui/Preloader";
import { TagsList } from "./components/TagsList";
import styles from "./Tags.module.scss";

export const Tags: RFC = () => {
  const { seaTagsData, isSeaTagsLoading } = useSeaGetTagsQuery();
  const { airTagsData, isAirTagsLoading } = useAirGetTagsQuery();
  const shipment = useAppSelector(searchFilterStore.selectors.shipment);
  const isLoading = isSeaTagsLoading || isAirTagsLoading;

  const hasTags = useMemo(() => {
    switch (shipment) {
      case ShipmentType.SEA:
        return seaTagsData?.length && seaTagsData?.length > 0;
      case ShipmentType.AIR:
        return airTagsData?.length && airTagsData?.length > 0;
    }
  }, [airTagsData, seaTagsData, shipment]);

  if (!hasTags) return null;

  return (
    <div className={cn(styles.tagsPanel)}>
      {isLoading && (
        <div className={styles.tagFilterLoaderContainer}>
          <Preloader />
        </div>
      )}
      <TagsList />
    </div>
  );
};
